import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  uploadedUrl: '',
  emailConfirmed: null,
  error: null,
  loading: false,
};

const sendsReceipts = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.UPLOAD_SENDS_BARCODE_LOADING:
      return { ...state, loading: true };

    case actionTypes.UPLOAD_SENDS_BARCODE_ERROR:
      return { ...state, loading: false, error: payload };

    case actionTypes.UPLOAD_SENDS_BARCODE_SUCCESS:
      return {
        ...state,
        uploadedUrl: payload,
      };

    case actionTypes.SENDS_EMAIL_RECEIPT_LOADING:
      return { ...state, loading: true };

    case actionTypes.SENDS_EMAIL_RECEIPT_ERROR:
      return { ...state, loading: false, error: payload };

    case actionTypes.SENDS_EMAIL_RECEIPT_SUCCESS:
      return {
        ...state,
        emailConfirmed: payload,
      };

    case actionTypes.UPLOAD_SENDS_BARCODE_CLEAR:
      return {
        ...INITIAL_STATE,
      };

    default:
      return state;
  }
};

export default sendsReceipts;
